<div class="version-search-dialog">
  <div class="version-search-dialog__header">
    <h2 class="version-search-dialog__title">Version Search</h2>
    <button type="button" mat-icon-button (click)="close()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="version-search-dialog__body">
    <app-version-attribute-search
      layout="versions-list"
      applyMode="manual"
      [eventId]="data.eventId"
      [totalVersionCount]="data.totalVersionCount">
    </app-version-attribute-search>
  </div>
</div>
